/*
 * dispenseEproDevicePopupModule
 * */

import dispenseEproDevicePopupComponent from './dispenseEproDevicePopup.component';

const dispenseEproDevicePopupModule = angular.module('app.components.dispenseEproDevicePopup', [])
	.component('dispenseEproDevicePopup', dispenseEproDevicePopupComponent)
	.name;

export default dispenseEproDevicePopupModule;
